<template>
    <div>
        <div v-if="dmnOptions.widgetMode === 'default-view'" class="tw-header">
            <font-awesome-icon v-if="dmnOptions.isModalMode" class="tw--close-icon" icon="window-close" v-on:click="closeModalWidget()" />

            <div class="tw-header__section tw-responsive__sm--block">
                <h3 v-if="currentStage" class="tw-text--left tw-responsive__xs--center tw-responsive__xxs--center tw-responsive__sm--center">
                    {{ currentStage.title }}
                </h3>
            </div>  

            <bread-crumbs v-bind:isLargeScreen="true"></bread-crumbs>
        </div>

        <div class="tw-header__section tw-text--right tw-responsive__xs--hide tw-responsive__md--hide tw-responsive__lg--hide" v-if="currentStage.id === 'tickets'">
            <buy-now-button v-bind:buttonPosition='"header-button-sm"'></buy-now-button>
        </div>

        <div class="tw-text--right tw-responsive__sm--hide tw-responsive__md--hide tw-responsive__lg--hide" v-if="currentStage.id === 'tickets'">
            <buy-now-button v-bind:buttonPosition='"header-button-block"'></buy-now-button>
        </div>

        <bread-crumbs v-if="dmnOptions.widgetMode === 'default-view'" v-bind:isLargeScreen="false"></bread-crumbs>
    </div>
</template>

<script lang="ts">
    import { Vue } from "vue-property-decorator";
    import { Component } from "vue-property-decorator";
    import TagOptions from '../../../models/TagOptions';
    import BreadCrumbs from '../bread-crumbs/BreadCrumbs.vue';
    import BuyNowButton from '../buy-now-button/BuyNowButton.vue';
    import TicketWidgetComponent from "../../TicketWidgetComponent";

    // fontawesome
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faWindowClose } from '@fortawesome/free-solid-svg-icons';

    library.add(faWindowClose);

    @Component({
        components: {
          BreadCrumbs,
          BuyNowButton,
          FontAwesomeIcon
        }
    })

    export default class WidgetHeader extends TicketWidgetComponent {
        mounted() {}

        closeModalWidget() {
            this.$root.$emit('closeModal');
        }
    }
</script>